import axios from 'axios';
import env from 'react-dotenv';

class Api {
  constructor() {
    this.axios = axios.create({
      baseURL: `${env.REACT_APP_API_URL}`,
    });
  }

  get = (url, options = {}) => {
    return this.axios.get(url, {
      ...options,
      headers: {
        Authorization: localStorage.getItem('accessToken'),
      },
    });
  };

  delete = (url, options) => {
    return this.axios.delete(url, {
      ...options,
      headers: {
        Authorization: localStorage.getItem('accessToken'),
      },
    });
  };

  patch = (url, data, options) => {
    return this.axios.patch(url, data, {
      ...options,
      headers: {
        Authorization: localStorage.getItem('accessToken'),
      },
    });
  };

  post = (url, data, options) => {
    return this.axios.post(url, data, {
      ...options,
      headers: {
        Authorization: localStorage.getItem('accessToken'),
      },
    });
  };

  put = (url, data, options) => {
    return this.axios.put(url, data, {
      ...options,
      headers: {
        Authorization: localStorage.getItem('accessToken'),
      },
    });
  };
}

export default new Api();
